import { get, patch, post } from "@insite/client-framework/Services/ApiService";
import { BaseModel, GetBundledProductsApiParameter, ProductModel } from "@insite/client-framework/Types/ApiModels";

export interface BundledProductsModel extends BaseModel {
    productSkus?: string[];
    products?: ProductModel[];
    isFeaturedProduct?: boolean;
}

const bundledProductsUrl = "api/v2/products";

export async function getBundledProducts(getBundledProductsParameter: GetBundledProductsApiParameter) {
    const result = await get<BundledProductsModel>(bundledProductsUrl, getBundledProductsParameter as any);
    return result;
}
